module.exports = __webpack_public_path__ + "static/media/red.c3a1cfdd.png";